<template>
    <div class='requests-container container-fluid home-container home-container-cp'>
        <div class='row div-row'>
            <div id='requests_left' class='div-container col-xs-6 col-sm-6 col-md-6 col-lg-6'>
                <div style="display: none;" class='requests-sub-nav sub-nav' v-show="displayContents(activeRequestsTab, 'info')">
                    <div @click.prevent="setActiveRequestInfoTabName('details')" class="details-vp" v-bind:class="{ 'details-vp-is-active' : displayContents(activeRequestInfoTab, 'details')}" v-if="displayContents(activeRequestsTab, 'info')">
                        PO
                    </div>
                    <div @click.prevent="setActiveRequestInfoTabName('files')" class="details-vp" v-bind:class="{ 'details-vp-is-active' : displayContents(activeRequestInfoTab, 'files')}" v-if="displayContents(activeRequestsTab, 'info') && jobType === 2">
                        Documents
                    </div>
                    <div @click.prevent="setActiveRequestInfoTabName('vos')" class="details-vp" v-bind:class="{ 'details-vp-is-active' : displayContents(activeRequestInfoTab, 'vos')}" v-if="displayContents(activeRequestsTab, 'info') && jobType !== 2">
                        VOS
                    </div>
                    <request-info-buttons v-show="displayContents(activeRequestInfoTab, 'details')"></request-info-buttons>
                </div>
                <div class='requests-main-form main-form main-form-cp'>
                    <div v-if="displayContents(activeRequestsTab, 'info')">
                        <interpretation-details v-if="displayContents(activeRequestInfoTab, 'details') && showInfo && jobType == 1"></interpretation-details>
                        <translation-details v-if="displayContents(activeRequestInfoTab, 'details') && showInfo && jobType == 2"></translation-details>
                        <telephonic-details v-if="displayContents(activeRequestInfoTab, 'details') && showInfo && (jobType == 3 || jobType == 4)"></telephonic-details>
                        <request-files v-if="displayContents(activeRequestInfoTab, 'files') && showInfo"></request-files>
                        <request-vos v-if="displayContents(activeRequestInfoTab, 'vos') && showInfo && jobType !== 2"></request-vos>
                        <request-form v-else-if="displayContents(activeRequestInfoTab, 'new-request') && showNewRequestForm"></request-form>
                    </div>
                    <view-requests v-else-if="displayContents(activeRequestsTab, 'view-requests')">
                    </view-requests>

                    <br/><br/><br/>
                </div>
            </div>
            <div id='requests_right' class='div-container col-xs-6 col-sm-6 col-md-6 col-lg-6'>
                <div id="right_container_appt">
                    <div class='container-data-table'>
                        <div>
                            <vendor-tables></vendor-tables>
                        </div>
                    </div>
                </div>
                <div class='overlay overlay-cp request-right-overlay new-request-overlay table-overlay'>
                    <div class='overlay-msg'>To continue, please finish entering the request details and click 'Submit Request'. </div>
                    <center><a id="cancel_request_btn" class="button is-link is-inverted is-outlined" @click="cancelNewRequest">Go Back</a></center>

                </div>
                <div class='overlay overlay-cp request-right-overlay cancel-request-overlay table-overlay'>
                    <div class='overlay-msg'>To continue, please finish entering the cancellation details and click 'Submit Cancellation'.</div>
                    <center><a id="cancel_request_btn" class="button is-link is-inverted is-outlined" @click="closeCancelRequest">Go Back</a></center>

                </div>
            </div>
            <div class='resizer resizer-cp requests-resizer'><div class='resizer-toggle requests-resizer-toggle'></div></div>

        </div>
        <div class='overlay overlay-cp resize-overlay resize-overlay-cp requests-resize-overlay'></div>

    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    computed: {

        ...mapState('nav', {
            activeRequestsTab: state => state.activeRequestsTab,
            activeRequestInfoTab: state => state.activeRequestInfoTab,
        }),

        ...mapState('cancelRequest', {
            cancelActive: state => state.cancelActive,
            cancelRequestedTick: state => state.cancelRequestedTick,
        }),

        ...mapGetters('requests', {
            showInfo: 'getShowInfo',
            clientType: 'getClientType',
            jobType: 'getJobType',
        }),

    },

    methods: {
        displayContents(activeName, name) {
            return activeName === name;
        },

        cancelNewRequest(){
            //Remove error messages
            //$('.error-container').empty();

            //$('.new-request-overlay').fadeOut('fast');

            //Re-select the first row in the table
            //$('#requests-table tbody tr:nth-child(1)').click();

            // VueStore.dispatch('newRequest/checkBeforeLeaving');
            // VueStore.dispatch('newRequest/setShowButton', {key: 'newRequestActive', bool: false})
        },

        closeCancelRequest(){
            //Remove error messages
            //$('.error-container').empty();

            //$('.cancel-request-overlay').fadeOut('fast');

            //Re-select the first row in the table
            //$('#requests-table tbody tr:nth-child(1)').click();

            VueStore.dispatch('cancelRequest/checkBeforeLeaving');
            VueStore.dispatch('cancelRequest/setShowButton', {key: 'cancelActive', bool: false})
        },

        newRequest(){
            //Remove error messages
            $('.error-container').empty();

            //Reload the table to remove any highlight
            $('#requests-table').DataTable().ajax.reload();

            $('.new-request-overlay').fadeIn('fast');

        },

        newCancelRequest(){
            //Remove error messages
            $('.error-container').empty();

            //Reload the table to remove any highlight
            $('#requests-table').DataTable().ajax.reload();

            $('.cancel-request-overlay').fadeIn('fast');

        },

        /**
         * Control tabs for details and files.
         * @param name
         */
        setActiveRequestInfoTabName(name){
            // set active request tab name
            VueStore.dispatch('nav/setVariables',{ key: 'activeRequestInfoTab', value: name});
        }
    },

    watch: {
        // the store increments this tick when a cancel is requested anywhere
        cancelRequestedTick () {
            this.newCancelRequest()
        }
    },

}

</script>

<style>

</style>
